export default __webpack_public_path__ + "static/media/BlackCurve.dc7c4498.svg";